import { Injectable } from '@angular/core'
import type { FormState } from '@app/shared/models/form.model'
import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita'
import { AhuImageService } from '@app/ahu/services/ahu-image.service'
import type { Ahu } from './ahu.model'

export interface AhuState extends EntityState<Ahu>, ActiveState {
  ui: {
    formState: FormState
  }
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'ahu', idKey: 'Id' })
export class AhuStore extends EntityStore<AhuState, Ahu> {
  constructor(private ahuImageService: AhuImageService) {
    super({
      ui: {
        formState: {
          isValid: true,
          isModified: false,
        },
      },
    })
  }

  akitaPreUpdateEntity(_: Readonly<Ahu>, nextEntity: Partial<Ahu>): Ahu {
    const ahu = super.akitaPreUpdateEntity(_, nextEntity)

    /*
     * If the AHU has a renderImage set with a decache flag, update the decache value
     */
    if (ahu.RenderImage) {
      const sourceWithNewDecacheTag = this.ahuImageService.updateCacheBusterInImageUrl(ahu.RenderImage.Source)
      return {
        ...ahu,
        RenderImage: { ...ahu.RenderImage, Source: sourceWithNewDecacheTag },
      }
    }

    return ahu
  }
}
